import { render, staticRenderFns } from "./PublicationModal.vue?vue&type=template&id=666c45ed&scoped=true&"
import script from "./PublicationModal.vue?vue&type=script&lang=js&"
export * from "./PublicationModal.vue?vue&type=script&lang=js&"
import style0 from "./PublicationModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PublicationModal.vue?vue&type=style&index=1&id=666c45ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c45ed",
  null
  
)

export default component.exports